"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimaryValue = void 0;
function getPrimaryValue(dict, primary_key) {
    var primary_value;
    if (typeof primary_key === "function") {
        primary_value = primary_key(dict);
    }
    else {
        primary_value = dict[primary_key];
    }
    return primary_value;
}
exports.getPrimaryValue = getPrimaryValue;
//# sourceMappingURL=json.js.map